import { RESULTS_WRAPPER_ID } from './constants'
import pickBy from 'lodash.pickby'
import mapValues from 'lodash.mapvalues'
import reduce from 'lodash.reduce'

export const getSelectedFilters = (filters) => {
  return pickBy(mapValues(filters, 'selected'), (selected) => selected.length)
}

export const getSelectedFiltersCount = (filters) =>
  reduce(getSelectedFilters(filters), (count, selected) => count + selected.length, 0)

export const getCookie = (name) => {
  // eslint-disable-next-line no-param-reassign
  name += '='
  const decodedCookies = decodeURIComponent(document.cookie).split(';')
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < decodedCookies.length; i++) {
    let cookie = decodedCookies[i]
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1)
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length)
    }
  }
  return ''
}

export const setCookie = (name, value, expires, path = '/') => {
  document.cookie = `${name}=${value};expires=${expires};path=${path}`
}

export const expireCookie = (name) => setCookie(name, '', 'expires=Thu, 01 Jan 1970 00:00:00 UTC')

const getElementOffsetFromRoot = (elementId) => {
  let offset
  const element = document.getElementById(elementId)
  if (element) {
    const bounds = element.getBoundingClientRect()
    offset = {
      x: bounds.x + document.documentElement.scrollLeft,
      y: bounds.y + document.documentElement.scrollTop,
    }
  }
  return offset
}

export const scrollToTopOfResults = () => {
  const offset = getElementOffsetFromRoot(RESULTS_WRAPPER_ID)
  if (offset) {
    window.scroll({
      left: 0,
      top: offset.y - 25,
    })
  }
}

export const NOOP = () => {}
